import { OrbitControls } from '@react-three/drei'

interface Props {
  orbitControls?: boolean
  axesHelper?: boolean
}

export const Utility = ({
  orbitControls = false,
  axesHelper = false,
}: Props): JSX.Element => {
  const isDevelopment = process.env.NODE_ENV !== 'production'

  return (
    <>
      {orbitControls && (
        <OrbitControls
          makeDefault
          // enablePan={false}
          maxPolarAngle={Math.PI / 2}
          minDistance={0.05}
          maxDistance={10}
          attach={'orbitControls'}
        />
      )}
      {axesHelper && isDevelopment && <axesHelper args={[1]} />}
    </>
  )
}
